<template>
	<section>
		<header-page
			actions
			name="accounting-periods"
			:title="title"
			@run-action="runAction"
		/>
		<app-actions
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<accounting-period-list
			:columns="columns"
			:current-page="currentPage"
			:items-total-quantity="table.itemTotal"
			:items-quantity="table.rows.length"
			:rows="table.rows"
			:last-page="table.lastPage"
			:subsidiary-id="subsidiaryId"
			:subsidiary-name="subsidiaryName"
			:years="years"
			:year="year"
			@on-page="changePage"
			@on-search="onSearch($event, 'period-con')"
			@set-year="setYear"
		/>
		<!--<section class="modal-filter-footer">
			<modal-sidebar-button
				success-text="Atrás"
				hidden
				@accept-button-clicked="goToCompanies"
			/>
		</section> -->
		<router-view></router-view>
	</section>
</template>

<script>
	import accountingPeriodList from '@/components/accounting-periods/accounting-period-list';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import backButtonRoute from '@/components/shared/back-button-route';
	import { mapActions, mapGetters } from 'vuex';
	import appActions from '@/components/shared/app-actions/app-actions';

	function created() {
		if (this.subsidiaryId) {
			this.params.subsidiaryId = Number(this.subsidiaryId);
		}
		this.loadData('period-con');
		// this.$loadAccountingPeriod({ context: this, params: this.params });
		this.loadYears();
	}

	async function loadYears() {
		const params = {
			subsidiaryId: this.subsidiaryId,
		};
		try {
			({ data: this.years } = await this.$http.get('com-year-accountant', { params }));
		} catch (error) {
			this.showGenericError();
		}
	}

	async function changePage(page) {
		this.params.page = page;
		this.currentPage = this.params.page;
		await this.loadData('period-con');
	}

	function runAction({ code }) {
		if (code === 'period-con-activate' || code === 'period-con-open' ||
			code === 'period-con-close') {
			const openOrClose = code === 'period-con-open' ? 'open' : 'close';
			const newCode = code === 'period-con-activate' ? 'active' : openOrClose;
			this.goTo(
				'accounting-period-activate',
				{ params: { subsidiaryId: this.params.subsidiaryId, code: newCode } },
			);
		}
	}

	function title() {
		return this.subsidiaryId ? `${this.subsidiaryName} - ${this.$route.meta.title}` :
			this.$route.meta.title;
	}

	function currentSubsidiary(newSubsidiary) {
		const { id, name } = newSubsidiary;
		this.params.subsidiaryId = Number(id);
		this.goTo('accounting-periods', { params: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } });
	}

	async function routeParamsHandler(newVal) {
		this.params.subsidiaryId = Number(newVal.subsidiaryId);
		await this.loadData('period-con');
	}

	async function setYear(value) {
		this.params.year = value.year;
		// this.$loadAccountingPeriod({ context: this, params: this.params });
		await this.loadData('period-con');
	}

	function goToCompanies() {
		this.goTo('companies');
	}

	function data() {
		return {
			columns: [
				{
					id: 1,
					name: 'Nombre',
					value: 'name',
					checked: true,
					visible: true,
				},
				{
					id: 2,
					name: 'Fecha de Inicio',
					value: 'startDate',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 3,
					name: 'Fecha Final',
					value: 'endDate',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 4,
					name: 'Fecha de Presentación',
					value: 'presentationDate',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 5,
					name: 'Cant. Registros',
					value: 'registersQuantity',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 6,
					name: 'Cant. Asientos',
					value: 'accountingEntriesQuantity',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 7,
					name: '',
					checked: true,
					visible: true,
					flagVisible: true,
				},
				{
					id: 8,
					name: '',
					checked: true,
					visible: true,
					flagVisible: true,
				},
				{
					id: 9,
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
				},
			],
			currentPage: 1,
			year: null,
			years: [],
			responseYear: [],
		};
	}

	export default {
		name: 'page-accounting-period',
		components: {
			accountingPeriodList,
			actionBar,
			appActions,
			backButtonRoute,
		},
		computed: {
			...mapGetters('subsidiary', [
				'getAccountingPeriod',
				'currentSubsidiary',
			]),
			title,
		},
		created,
		data,
		methods: {
			...mapActions('subsidiary', {
				$loadAccountingPeriod: 'loadAccountingPeriod',
			}),
			changePage,
			goToCompanies,
			loadYears,
			routeParamsHandler,
			runAction,
			setYear,
		},
		props: {
			subsidiaryId: [Number, String],
			subsidiaryName: String,
		},
		watch: {
			'$route.params': routeParamsHandler,
			currentSubsidiary,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-accounting-period.vue